module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"logged_in_as_other_user":"{userEmail}としてログイン中"},"en":{"logged_in_as_other_user":"You are logged in as {userEmail}"}}')
  delete Component.options._Ctor
}
